export default __webpack_public_path__ + "static/media/gl_edit_16.7b3d4884.svg";